// src/components/RelationshipManagerDashboard.js

import React from "react";
import RMDashboard from "./RMDashboard";
const RelationshipManagerDashboard = () => {
  return <RMDashboard />;
};

export default RelationshipManagerDashboard;
